import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import ReviewDetail from './pages/ReviewDetail';
import Search from './pages/Search';
import Categories from './pages/Categories';
import CategoryReviews from './pages/CategoryReviews';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminReviews from './pages/admin/AdminReviews';
import ReviewForm from './pages/admin/ReviewForm';
import AdminComments from './pages/admin/AdminComments';
import AdminCategories from './pages/admin/AdminCategories';
import AdminTags from './pages/admin/AdminTags';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <>
              <Navbar />
              <Home />
              <Footer />
            </>
          } />
          
          <Route path="/reviews" element={
            <>
              <Navbar />
              <Home />
              <Footer />
            </>
          } />
          
          <Route path="/review/:slug" element={
            <>
              <Navbar />
              <ReviewDetail />
              <Footer />
            </>
          } />
          
          <Route path="/search" element={
            <>
              <Navbar />
              <Search />
              <Footer />
            </>
          } />
          
          <Route path="/categories" element={
            <>
              <Navbar />
              <Categories />
              <Footer />
            </>
          } />
          
          <Route path="/category/:slug" element={
            <>
              <Navbar />
              <CategoryReviews />
              <Footer />
            </>
          } />

          {/* Admin Routes */}
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="reviews/create" element={<ReviewForm />} />
            <Route path="reviews/:id/edit" element={<ReviewForm />} />
            <Route path="comments" element={<AdminComments />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="tags" element={<AdminTags />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;